<div class="technical-error-container">
  <debtor-panel-error
    (reloadRequested)="handleReload()"
  />
</div>
